import { Injectable } from '@angular/core';

@Injectable()
export class WeeklyAdCommon {
	
	constructor(
		
	) {

	}

	public commonMethod(){
		console.log("Hello Weekly Ad");
	}
}



// WEBPACK FOOTER //
// ./src/modules/weekly-ad/pages/weekly-ad/weekly-ad.common.ts